//lib
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EncircledPlusIcon } from "../../../../../utils/svg-components";

//src
import { linkedContactsColumns } from "./columns";
import Table from "../../../../../components/table/table";
import { Button } from "../../../../../components/button/button";
import useContactsByCompany from "../../../../../hooks/useContactsByCompany";
import CreateContactModal from "../../../../contacts/create-contact/create-contact-modal";
import AddContactsToCompanyModal from "./add-contacts-company-modal/add-contacts-to-company-modal";
import { contactsCollection } from "../../../../../services/firebase";

const LinkedContactsTable = ({ companyID, companyName }) => {
  const [createContact, setCreateContact] = useState(false);
  const [showAddContactsToCompanyModal, setShowAddContactsToCompanyModal] = useState(false);
  const { data: contacts, isLoading, refetch } = useContactsByCompany(companyID);

  const navigate = useNavigate();

  const handleRemoveContact = async (contact) => {
    const isConfirmed = window.confirm(
      `Are you sure? Removing this contact will unlink it from the company. This contact will not be deleted.`
    );

    if (isConfirmed) {
      try {
        const contactRef = contactsCollection.doc(contact.id);
        await contactRef.update({ companyID: "" }); // Clear company name
        refetch(); // Refresh the contacts list
      } catch (error) {
        console.error("Error removing contact:", error);
        alert("Failed to remove contact. Please try again.");
      }
    }
  };

  const noDataMessage = (
    <div className="no-data">
      <div className="content">
        <Typography style={{ fontWeight: "bold" }} variant="h6">
          There are no contacts associated with this company.
        </Typography>
        <div className="noContact">
          <Button
            onClick={() => setCreateContact(true)}
            variant="filled"
            color={"tertiary"}
            size="large"
            startIcon={<EncircledPlusIcon />}
          >
            Add New Contact
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Table
        data={contacts}
        columns={linkedContactsColumns(handleRemoveContact, navigate)}
        customNoData={noDataMessage}
      />
      {contacts && contacts.length > 0 && (
        <div className="noContact2">
          {/* <Button
            size="large"
            startIcon={<EncircledPlusIcon />}
            variant="filled"
            color={"primary"}
            onClick={() => setShowAddContactsToCompanyModal(true)}
          >
            Add Existing Contact
          </Button> */}
          <Button
            onClick={() => setCreateContact(true)}
            variant="filled"
            color={"tertiary"}
            size="large"
            startIcon={<EncircledPlusIcon />}
          >
            Add New Contact
          </Button>
        </div>
      )}
      {createContact && (
        <CreateContactModal
          defaultCompanyName={companyName}
          onClose={() => setCreateContact(false)}
          onSuccess={() => {
            window.location.reload();
            setCreateContact(false);
          }}
        />
      )}

      {showAddContactsToCompanyModal && (
        <AddContactsToCompanyModal
          companyID={companyID}
          companyName={companyName}
          onClose={() => setShowAddContactsToCompanyModal(false)}
          onSuccess={() => {
            refetch();
            setShowAddContactsToCompanyModal(false);
          }}
        />
      )}
    </div>
  );
};

export default LinkedContactsTable;
